import { Component, input, output } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "app-page-error",
  imports: [MatIconModule],
  templateUrl: "./page-error.component.html",
  styleUrl: "./page-error.component.scss",
})
export class PageErrorComponent {
  readonly icon = input<string>("error");
  readonly title = input<string>(
    "Something went wrong while loading the page.",
  );
  readonly message = input<string>("");
  readonly primaryActionLabel = input<string | undefined>(undefined);
  readonly primaryActionLink = input<string | undefined>(undefined);
  readonly secondaryActionLabel = input<string | undefined>(undefined);
  readonly secondaryActionLink = input<string | undefined>(undefined);

  readonly primaryActionClick = output<void>();
  readonly secondaryActionClick = output<void>();

  onPrimaryActionClick(event: Event): void {
    if (!this.primaryActionLink()) {
      event.preventDefault();
      this.primaryActionClick.emit();
    }
  }

  onSecondaryActionClick(event: Event): void {
    if (!this.secondaryActionLink()) {
      event.preventDefault();
      this.secondaryActionClick.emit();
    }
  }
}
